import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `ContractNamesControllerStateProvider` not mounted on RN.
export default function useContractNamesController(): any {
  const { state } = useController('ContractNamesController' as any)
  return state as any
}
